import { CRadioGroupItem } from '../../../components';

export const items: CRadioGroupItem[] = [
  { name: 'Radio 1', value: 'one' },
  { name: 'Radio 2', value: 'two' },
  { name: 'Radio 3', value: 'three' },
];
